// Reconstructed from the supplied production build; original component names were unavailable.
import {
  AnimatePresence,
  ArrowLeftIcon,
  ArrowRightIcon,
  CheckIcon,
  CircleAlertIcon,
  CodeIcon,
  Helmet,
  InfoIcon,
  Link,
  MapPinIcon,
  PackageIcon,
  PhoneIcon,
  PlayIcon,
  React,
  SaveIcon,
  ShoppingCartIcon,
  SquarePenIcon,
  TagIcon,
  TruckIcon,
  XIcon,
  jsxRuntime,
  motion,
  useNavigate,
  useParams,
} from "../vendor/runtime.js";
import { useAuth } from "../context/AuthContext.jsx";
import { SERVER_URL, RAZORPAY_KEY_ID } from "../config.js";
import { api } from "../api/client.js";
import { Navbar } from "../components/Navbar.jsx";
import { Button } from "../components/Button.jsx";
import { Footer } from "../components/Footer.jsx";
const ProductDetailsPage = () => {
  const { id: a } = useParams(),
    { currentUser: n } = useAuth(),
    i = useNavigate(),
    [l, c] = React.useState(null),
    [u, m] = React.useState(true),
    [f, x] = React.useState(null),
    [p, g] = React.useState("details"),
    [b, y] = React.useState(null),
    [w, N] = React.useState(""),
    [T, C] = React.useState(null),
    [A, O] = React.useState(false),
    M = SERVER_URL,
    [Y, R] = React.useState(0),
    U = React.useRef(null),
    [W, B] = React.useState({
      inProgress: false,
      success: false,
      error: null,
    }),
    [G, te] = React.useState({
      phone: "",
      address: "",
      isEditingPhone: false,
      isEditingAddress: false,
      validationErrors: {},
      isSaving: false,
      updateMessage: "",
    }),
    ne = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.5,
        },
      },
    },
    de = {
      hidden: {
        opacity: 0,
      },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
        },
      },
    },
    [Me, Ce] = React.useState(null),
    we = (_) => {
      const ee =
          /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/,
        ye = _.match(ee);
      return ye ? ye[1] : null;
    },
    L = (_) => `https://img.youtube.com/vi/${_}/hqdefault.jpg`,
    X = (_) => `https://www.youtube.com/embed/${_}?autoplay=1&rel=0&modestbranding=1`,
    se = (_) => {
      if (U.current) {
        const ee = U.current.clientWidth;
        (U.current.scrollTo({
          left: _ * ee,
          behavior: "smooth",
        }),
          R(_));
      }
    },
    re = () => {
      if (U.current) {
        const _ = U.current.scrollLeft,
          ee = U.current.clientWidth,
          ye = Math.round(_ / ee);
        R(ye);
      }
    };
  (React.useEffect(() => {
    l &&
      (y({
        original_amount: parseFloat(l.amount),
        final_amount: parseFloat(l.amount),
        discount: 0,
        coupon_applied: null,
      }),
      N(""),
      O(false),
      C(null));
  }, [l]),
    React.useEffect(() => {
      (async () => {
        try {
          m(true);
          const ee = await api.get(`/products/${a}`);
          (c(ee.data),
            ee.data.category === "hardware" &&
              n &&
              te((ye) => ({
                ...ye,
                phone: n.phone || "",
                address: n.address || "",
              })));
        } catch (ee) {
          (console.error("API Error:", ee),
            x(
              ee.response
                ? `Failed to fetch project details: ${ee.response.status} ${ee.response.statusText}`
                : "Network error when connecting to the server",
            ));
        } finally {
          m(false);
        }
      })();
    }, [a, n]));
  const k = () => {
      const _ = {};
      return (
        (l == null ? undefined : l.category) === "hardware" &&
          (G.phone.trim()
            ? /^[+]?[\d\s\-\(\)]{10,}$/.test(G.phone.trim()) ||
              (_.phone = "Please enter a valid phone number")
            : (_.phone = "Phone number is required for hardware delivery"),
          G.address.trim()
            ? G.address.trim().length < 10 &&
              (_.address = "Please provide a complete delivery address")
            : (_.address = "Delivery address is required for hardware delivery")),
        te((ee) => ({
          ...ee,
          validationErrors: _,
        })),
        Object.keys(_).length === 0
      );
    },
    Q = (_, ee) => {
      te((ye) => ({
        ...ye,
        [_]: ee,
        validationErrors: {
          ...ye.validationErrors,
          [_]: "",
        },
      }));
    },
    ae = async (_, ee) => {
      try {
        te((He) => ({
          ...He,
          isSaving: true,
        }));
        const ye = {};
        ye[_] = ee;
        const Ge = await api.patch("/auth/user/contact", ye);
        if (Ge.data.success || Ge.status === 200)
          return (
            te((He) => ({
              ...He,
              updateMessage: `${_ === "phone" ? "Phone number" : "Address"} updated successfully!`,
              isSaving: false,
            })),
            setTimeout(() => {
              te((He) => ({
                ...He,
                updateMessage: "",
              }));
            }, 3e3),
            true
          );
      } catch (ye) {
        return (
          console.error(`Failed to update ${_} in backend:`, ye),
          te((Ge) => ({
            ...Ge,
            updateMessage:
              ye.response?.data?.error ||
              `Failed to update ${_ === "phone" ? "phone number" : "address"}. Please try again.`,
            isSaving: false,
          })),
          setTimeout(() => {
            te((Ge) => ({
              ...Ge,
              updateMessage: "",
            }));
          }, 3e3),
          false
        );
      }
    },
    J = async (_) => {
      const ee = _ === "phone" ? G.phone : G.address;
      (await ae(_, ee),
        te((ye) => ({
          ...ye,
          [`isEditing${_.charAt(0).toUpperCase() + _.slice(1)}`]: false,
        })),
        k());
    },
    ce = () =>
      new Promise((_) => {
        if (window.Razorpay) {
          _(true);
          return;
        }
        const ee = document.createElement("script");
        ((ee.src = "https://checkout.razorpay.com/v1/checkout.js"),
          (ee.onload = () => _(true)),
          (ee.onerror = () => _(false)),
          document.body.appendChild(ee));
      }),
    je = () => {
      (N(""),
        O(false),
        C(null),
        l &&
          y({
            original_amount: parseFloat(l.amount),
            final_amount: parseFloat(l.amount),
            discount: 0,
            coupon_applied: null,
          }));
    },
    he = async () => {
      var _, ee;
      if (!l || !w.trim()) {
        C("Please enter a coupon code");
        return;
      }
      try {
        (B({
          inProgress: true,
          success: false,
          error: null,
        }),
          C(null));
        const ye = await api.post("/coupons/validate", {
          code: w.trim(),
          productCategory: l.category,
          originalAmount: parseFloat(l.amount),
        });
        (y({
          original_amount: parseFloat(l.amount),
          final_amount: ye.data.finalAmount,
          discount: ye.data.discount,
          coupon_applied: w.trim(),
        }),
          O(true),
          B({
            inProgress: false,
            success: false,
            error: null,
          }));
      } catch (ye) {
        (C(
          ((ee = (_ = ye.response) == null ? undefined : _.data) == null ? undefined : ee.error) ||
            "Invalid coupon code",
        ),
          O(false),
          y({
            original_amount: parseFloat(l.amount),
            final_amount: parseFloat(l.amount),
            discount: 0,
            coupon_applied: null,
          }),
          B({
            inProgress: false,
            success: false,
            error: null,
          }));
      }
    },
    ot = async () => {
      var _, ee;
      if (!n) {
        i("/login", {
          state: {
            returnUrl: `/products/${a}`,
          },
        });
        return;
      }
      if (!((l == null ? undefined : l.category) === "hardware" && !k()))
        try {
          B({
            inProgress: true,
            success: false,
            error: null,
          });
          const ye = {
              product_id: l.id,
              coupon_code: A && w.trim() ? w.trim() : null,
              currency: "INR",
            },
            He = (await api.post("/create-order", ye)).data;
          if (A && b && Math.abs(He.final_amount - b.final_amount) > 0.01) {
            (B({
              inProgress: false,
              success: false,
              error: "Coupon validation changed. Please try again.",
            }),
              y({
                original_amount: He.original_amount,
                final_amount: He.final_amount,
                discount: He.discount,
                coupon_applied: He.coupon_applied,
              }));
            return;
          }
          y({
            original_amount: He.original_amount,
            final_amount: He.final_amount,
            discount: He.discount,
            coupon_applied: He.coupon_applied,
          });
          const { order: ct } = He;
          if (!ct || !ct.id) {
            B({
              inProgress: false,
              success: false,
              error: "Failed to create payment order",
            });
            return;
          }
          if (!(await ce())) {
            B({
              inProgress: false,
              success: false,
              error: "Razorpay SDK failed to load",
            });
            return;
          }
          if (!RAZORPAY_KEY_ID) {
            B({
              inProgress: false,
              success: false,
              error: "Razorpay is not configured. Set razorpayKeyId in public/runtime-config.js.",
            });
            return;
          }
          const el = {
            key: RAZORPAY_KEY_ID,
            amount: ct.amount,
            currency: ct.currency,
            name: "CodeBruh",
            description: l.title,
            order_id: ct.id,
            handler: async function (ea) {
              var tl, fr;
              try {
                B({
                  inProgress: true,
                  success: false,
                  error: null,
                });
                const ta = {
                  razorpay_order_id: ea.razorpay_order_id,
                  razorpay_payment_id: ea.razorpay_payment_id,
                  razorpay_signature: ea.razorpay_signature,
                  user_id: n.id,
                  product_id: l.id,
                  coupon_code: A && w.trim() ? w.trim() : null,
                };
                (l.category === "hardware" &&
                  ((ta.delivery_phone = G.phone), (ta.delivery_address = G.address)),
                  await api.post("/verify-payment", ta),
                  B({
                    inProgress: false,
                    success: true,
                    error: null,
                  }),
                  setTimeout(() => {
                    i("/my", {
                      state: {
                        newPurchase: l.id,
                      },
                    });
                  }, 2e3));
              } catch (ta) {
                (console.error("Payment verification error:", ta),
                  B({
                    inProgress: false,
                    success: false,
                    error:
                      ((fr = (tl = ta.response) == null ? undefined : tl.data) == null
                        ? undefined
                        : fr.error) || "Payment verification failed.",
                  }));
              }
            },
            modal: {
              ondismiss: function () {
                B({
                  inProgress: false,
                  success: false,
                  error: null,
                });
              },
            },
            prefill: {
              name: (n == null ? undefined : n.name) || "",
              email: (n == null ? undefined : n.email) || "",
              contact: G.phone || (n == null ? undefined : n.phone) || "",
            },
            theme: {
              color: "#4f46e5",
            },
          };
          new window.Razorpay(el).open();
        } catch (ye) {
          (console.error("Payment Init Error:", ye),
            B({
              inProgress: false,
              success: false,
              error:
                ((ee = (_ = ye.response) == null ? undefined : _.data) == null
                  ? undefined
                  : ee.error) || "Something went wrong during payment initiation.",
            }));
        }
    };
  if (u)
    return (
      <div
        className={
          "min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 flex items-center justify-center"
        }
      >
        <motion.div
          initial={{
            scale: 0.8,
            opacity: 0,
          }}
          animate={{
            scale: 1,
            opacity: 1,
          }}
          className={"flex flex-col items-center px-4"}
        >
          <div
            className={"relative w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 mb-3 md:mb-4 lg:mb-6"}
          >
            <div className={"absolute inset-0 border-4 border-indigo-100 rounded-full"} />
            <div
              className={
                "absolute inset-0 border-4 border-transparent border-t-indigo-600 rounded-full animate-spin"
              }
            />
          </div>
          <p className={"text-indigo-600 font-medium text-sm md:text-base lg:text-lg text-center"}>
            {"Loading project details..."}
          </p>
        </motion.div>
      </div>
    );
  if (f || !l)
    return (
      <div className={"min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100"}>
        <Navbar />
        <div
          className={
            "w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 lg:py-16 flex items-center justify-center"
          }
        >
          <motion.div
            className={
              "text-center bg-white rounded-xl md:rounded-2xl lg:rounded-3xl shadow-xl p-6 md:p-8 lg:p-12 max-w-md w-full border border-slate-100"
            }
            initial={"hidden"}
            animate={"visible"}
            variants={ne}
          >
            <div
              className={
                "w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 mx-auto mb-3 md:mb-4 lg:mb-6 rounded-full bg-red-100 flex items-center justify-center"
              }
            >
              <CircleAlertIcon className={"w-6 h-6 md:w-8 md:h-8 lg:w-10 lg:h-10 text-red-600"} />
            </div>
            <h2
              className={
                "text-lg md:text-xl lg:text-2xl font-bold text-gray-900 mb-2 md:mb-3 lg:mb-4"
              }
            >
              {"Project Not Found"}
            </h2>
            <p
              className={
                "mb-4 md:mb-6 lg:mb-8 text-slate-600 text-xs md:text-sm lg:text-base leading-relaxed"
              }
            >
              {f || "This project doesn't exist or has been removed."}
            </p>
            <Link to={"/products"} className={"block"}>
              <Button
                variant={"primary"}
                className={
                  "w-full group px-3 md:px-4 lg:px-6 py-2 md:py-2.5 lg:py-3 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white rounded-lg md:rounded-xl font-medium shadow-lg hover:shadow-xl transition-all duration-300 text-xs md:text-sm lg:text-base"
                }
              >
                <ArrowLeftIcon
                  className={
                    "mr-2 h-3 w-3 md:h-4 md:w-4 group-hover:-translate-x-1 transition-transform"
                  }
                />
                {"Browse All Projects"}
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    );
  const Re = l.faq
      ? l.faq
          .split(
            `
`,
          )
          .filter((_) => _.trim() !== "")
          .map((_) => {
            const ee = _.split(":");
            return {
              question: ee[0].trim(),
              answer: ee.slice(1).join(":").trim(),
            };
          })
      : [],
    Mt = l.features ? l.features.split(",").map((_) => _.trim()) : [],
    Ss = l.demo
      ? l.demo
          .split(",")
          .map((_) => _.trim())
          .filter((_) => _ !== "")
      : [],
    Tt = 1 + Ss.length;
  return (
    <div
      className={
        "min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 flex flex-col"
      }
    >
      <style jsx={true}>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .snap-x {
          scroll-snap-type: x mandatory;
        }
        .snap-center {
          scroll-snap-align: center;
        }
      `}</style>
      <Navbar />
      <Helmet>
        <title>
          {l != null && l.title ? `${l.title} | Codebruh` : "Project Details | Codebruh.in"}
        </title>
        <meta
          name={"description"}
          content={
            "Buy verified final year engineering projects with full source code, documentation, and video demos. Delivered instantly by Codebruh.in."
          }
        />
        <meta
          name={"keywords"}
          content={
            "final year projects, buy final year projects, CSE final year projects, project source code, project with report and video, React Node project, mini projects IT, verified academic projects, codebruh projects, student project marketplace, B.Tech project ideas, engineering projects India, codebruh.kestroinfotech.com"
          }
        />
        <meta
          property={"og:title"}
          content={(l == null ? undefined : l.title) || "Final Year Project | Codebruh"}
        />
        <meta
          property={"og:description"}
          content={
            "Explore and purchase top-rated final year projects with instant access to code, video, and documentation."
          }
        />
        <meta property={"og:url"} content={`https://codebruh.kestroinfotech.com/product/${a}`} />
        <meta property={"og:site_name"} content={"Codebruh.in"} />
        <meta name={"author"} content={"Codebruh Team"} />
      </Helmet>
      <section
        className={
          "bg-gradient-to-r from-cyan-500/10 via-blue-500/10 to-purple-500/10 bg-slate-900 pt-5 relative overflow-hidden"
        }
      >
        <div className={"absolute inset-0 bg-black/10"} />
        <div className={"absolute inset-0"}>
          <div
            className={
              "absolute top-0 left-1/4 w-32 h-32 md:w-48 md:h-48 lg:w-72 lg:h-72 bg-white/5 rounded-full blur-3xl"
            }
          />
          <div
            className={
              "absolute bottom-0 right-1/4 w-40 h-40 md:w-64 md:h-64 lg:w-96 lg:h-96 bg-white/5 rounded-full blur-3xl"
            }
          />
        </div>
        <div className={"relative pt-20 md:pt-16 lg:pt-24 pb-8 md:pb-12 lg:pb-16"}>
          <div className={"w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"}>
            <motion.div className={"w-full"} initial={"hidden"} animate={"visible"} variants={ne}>
              <nav
                className={
                  "mb-3 md:mb-4 lg:mb-6 text-[10px] md:text-xs lg:text-sm flex items-center text-indigo-100 overflow-x-auto whitespace-nowrap"
                }
              >
                <Link to={"/"} className={"hover:text-white transition-colors"}>
                  {"Home"}
                </Link>
                <span className={"mx-1 md:mx-2"}>{"/"}</span>
                <Link to={"/products"} className={"hover:text-white transition-colors"}>
                  {"Projects"}
                </Link>
                <span className={"mx-1 md:mx-2"}>{"/"}</span>
                <span className={"text-white font-medium truncate"}>{l.title}</span>
              </nav>
              <h1
                className={
                  "text-lg md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-white mb-3 md:mb-4 lg:mb-6 leading-tight"
                }
              >
                {l.title}
              </h1>
              <div className={"flex flex-wrap items-center gap-1 md:gap-2 lg:gap-4"}>
                <span
                  className={
                    "bg-blue-300 backdrop-blur-sm px-2 md:px-3 lg:px-4 py-1 md:py-1.5 lg:py-2 rounded-full text-[10px] md:text-xs lg:text-sm font-semibold"
                  }
                >
                  {l.category === "hardware" ? "Hardware" : l.category}
                </span>
                <span
                  className={
                    "flex items-center bg-blue-300 backdrop-blur-sm px-2 md:px-3 lg:px-4 py-1 md:py-1.5 lg:py-2 rounded-full"
                  }
                >
                  <CodeIcon className={"w-2 h-2 md:w-3 md:h-3 lg:w-4 lg:h-4 mr-1 md:mr-2"} />
                  <span className={"text-[10px] md:text-xs lg:text-sm"}>{l.language}</span>
                </span>
                {l.category === "hardware" && (
                  <span
                    className={
                      "flex items-center bg-green-300 backdrop-blur-sm px-2 md:px-3 lg:px-4 py-1 md:py-1.5 lg:py-2 rounded-full"
                    }
                  >
                    <TruckIcon className={"w-2 h-2 md:w-3 md:h-3 lg:w-4 lg:h-4 mr-1 md:mr-2"} />
                    <span className={"text-[10px] md:text-xs lg:text-sm"}>
                      {"Physical Delivery"}
                    </span>
                  </span>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      {G.updateMessage && (
        <div className={"fixed top-4 right-4 z-50"}>
          <motion.div
            initial={{
              opacity: 0,
              x: 100,
            }}
            animate={{
              opacity: 1,
              x: 0,
            }}
            exit={{
              opacity: 0,
              x: 100,
            }}
            className={`px-4 md:px-6 py-2 md:py-3 rounded-lg shadow-lg text-xs md:text-sm ${G.updateMessage.includes("successfully") ? "bg-green-500 text-white" : "bg-red-500 text-white"}`}
          >
            {G.updateMessage}
          </motion.div>
        </div>
      )}
      <main
        className={
          "flex-grow w-full  mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-8 lg:py-12 -mt-4 md:-mt-6 lg:-mt-8"
        }
      >
        <motion.div className={"w-full"} initial={"hidden"} animate={"visible"} variants={de}>
          <motion.div
            className={
              "bg-white rounded-xl lg:rounded-2xl shadow-xl overflow-hidden mb-6 lg:mb-8 border border-slate-100"
            }
            variants={ne}
          >
            <div className={"grid grid-cols-1 lg:grid-cols-2 gap-0"}>
              <div
                className={
                  "relative bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-900 order-1 lg:order-1 overflow-hidden"
                }
              >
                <div className={"absolute inset-0 opacity-10"}>
                  <div
                    className={
                      "absolute top-0 left-0 w-full h-full bg-gradient-to-br from-cyan-400/20 via-blue-500/20 to-purple-600/20"
                    }
                  />
                  <div
                    className={
                      "absolute top-1/4 left-1/4 w-20 h-20 lg:w-32 lg:h-32 bg-white/5 rounded-full blur-2xl animate-pulse"
                    }
                  />
                  <div
                    className={
                      "absolute bottom-1/4 right-1/4 w-16 h-16 lg:w-24 lg:h-24 bg-indigo-400/10 rounded-full blur-xl animate-pulse delay-1000"
                    }
                  />
                </div>
                <div
                  className={
                    "aspect-square lg:aspect-auto lg:h-full w-full relative overflow-hidden"
                  }
                >
                  <div
                    ref={U}
                    className={
                      "flex overflow-x-auto overflow-y-hidden h-full scrollbar-hide snap-x snap-mandatory"
                    }
                    style={{
                      scrollBehavior: "smooth",
                    }}
                    onScroll={re}
                  >
                    <div
                      className={
                        "min-w-full h-full flex items-center justify-center p-4 lg:p-8 snap-center relative"
                      }
                    >
                      <div className={"absolute inset-0 flex items-center justify-center"}>
                        <div
                          className={
                            "w-2/3 h-2/3 bg-gradient-to-br from-cyan-400/20 via-blue-500/20 to-purple-600/20 rounded-2xl blur-2xl animate-pulse"
                          }
                        />
                      </div>
                      <div
                        className={
                          "relative z-10 w-full h-full flex items-center justify-center group"
                        }
                      >
                        <div
                          className={
                            "relative transform transition-all duration-500 group-hover:scale-105"
                          }
                        >
                          <div
                            className={
                              "relative bg-white/10 backdrop-blur-sm rounded-lg lg:rounded-xl border border-white/20 shadow-xl overflow-hidden"
                            }
                          >
                            <img
                              src={M + l.image}
                              alt={l.title + " by code bruh"}
                              className={
                                "w-full h-full object-contain p-4 lg:p-6 transition-all duration-500"
                              }
                            />
                            <div
                              className={
                                "absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-white/10 pointer-events-none"
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {Ss.map((_, ee) => {
                      const ye = we(_);
                      if (!ye) return null;
                      const Ge = Me === `demo-${ee}`;
                      return (
                        <div
                          key={ee}
                          className={
                            "min-w-full h-full flex items-center justify-center p-4 lg:p-8 snap-center relative"
                          }
                        >
                          <div className={"absolute inset-0 flex items-center justify-center"}>
                            <div
                              className={
                                "w-2/3 h-2/3 bg-gradient-to-br from-red-400/20 via-pink-500/20 to-purple-600/20 rounded-2xl blur-2xl animate-pulse"
                              }
                            />
                          </div>
                          <div
                            className={
                              "relative z-10 w-full h-full flex items-center justify-center group max-w-2xl"
                            }
                          >
                            <div
                              className={
                                "relative transform transition-all duration-500 group-hover:scale-105 w-full"
                              }
                            >
                              <div
                                className={
                                  "relative bg-white/10 backdrop-blur-sm rounded-lg lg:rounded-xl border border-white/20 shadow-xl overflow-hidden"
                                }
                              >
                                <div className={"aspect-video relative w-full"}>
                                  {Ge ? (
                                    <jsxRuntime.Fragment>
                                      <iframe
                                        src={X(ye)}
                                        title={`Demo video ${ee + 1} for ${l.title}`}
                                        className={"w-full h-full absolute inset-0"}
                                        frameBorder={"0"}
                                        allow={
                                          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        }
                                        allowFullScreen={true}
                                      />
                                      <button
                                        onClick={() => Ce(null)}
                                        className={
                                          "absolute top-2 right-2 w-5 h-5 lg:w-6 lg:h-6 bg-black/70 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-red-600 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white/50 z-50"
                                        }
                                        aria-label={"Close video"}
                                      >
                                        <XIcon className={"w-3 h-3 lg:w-4 lg:h-4"} />
                                      </button>
                                    </jsxRuntime.Fragment>
                                  ) : (
                                    <jsxRuntime.Fragment>
                                      <img
                                        src={L(ye)}
                                        alt={`Demo video ${ee + 1} for ${l.title}`}
                                        className={"w-full h-full object-cover"}
                                        onError={(He) => {
                                          He.target.src = `https://img.youtube.com/vi/${ye}/hqdefault.jpg`;
                                        }}
                                      />
                                      <div
                                        className={
                                          "absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center"
                                        }
                                      >
                                        <button
                                          onClick={() => Ce(`demo-${ee}`)}
                                          className={
                                            "w-16 h-16 lg:w-20 lg:h-20 bg-red-600/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-2xl hover:bg-red-500 transition-all duration-300 transform hover:scale-110 group/play focus:outline-none focus:ring-4 focus:ring-red-500/50"
                                          }
                                          aria-label={`Play demo video ${ee + 1}`}
                                        >
                                          <PlayIcon
                                            className={
                                              "w-7 h-7 lg:w-9 lg:h-9 text-white ml-1 group-hover/play:scale-110 transition-transform"
                                            }
                                          />
                                        </button>
                                      </div>
                                    </jsxRuntime.Fragment>
                                  )}
                                  {!Ge && (
                                    <div
                                      className={"absolute top-2 lg:top-3 right-2 lg:right-3 z-40"}
                                    >
                                      <div
                                        className={
                                          "bg-black/70 backdrop-blur-sm text-white px-2 lg:px-3 py-1 lg:py-1.5 rounded-full text-xs lg:text-sm font-medium"
                                        }
                                      >
                                        {"YouTube"}
                                      </div>
                                    </div>
                                  )}
                                </div>
                                {!Ge && (
                                  <div className={"p-3 lg:p-4 bg-white/5 backdrop-blur-sm"}>
                                    <h4
                                      className={"font-bold text-white text-sm lg:text-base mb-1"}
                                    >
                                      {"Demo Video"}
                                    </h4>
                                  </div>
                                )}
                                <div
                                  className={
                                    "absolute inset-0 bg-gradient-to-tr from-transparent via-white/5 to-white/10 pointer-events-none"
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  {Tt > 1 && (
                    <div
                      className={
                        "absolute bottom-3 lg:bottom-4 left-1/2 transform -translate-x-1/2 z-20"
                      }
                    >
                      <div className={"flex space-x-2"}>
                        {Array.from(
                          {
                            length: Tt,
                          },
                          (_, ee) => (
                            <button
                              key={ee}
                              onClick={() => se(ee)}
                              className={`w-2 h-2 lg:w-3 lg:h-3 rounded-full transition-all duration-300 ${ee === Y ? (ee === 0 ? "bg-white border-2 border-white/50 scale-125" : "bg-red-500 border-2 border-red-400/50 scale-125") : ee === 0 ? "bg-white/50 border border-white/30 hover:bg-white/70" : "bg-red-500/50 border border-red-400/50 hover:bg-red-500/70"}`}
                              aria-label={`Go to slide ${ee + 1}`}
                            />
                          ),
                        )}
                      </div>
                    </div>
                  )}
                  {Tt > 1 && (
                    <jsxRuntime.Fragment>
                      <button
                        onClick={() => se(Y > 0 ? Y - 1 : Tt - 1)}
                        className={
                          "absolute left-2 lg:left-4 top-1/2 transform -translate-y-1/2 z-30 w-8 h-8 lg:w-10 lg:h-10 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white/50 opacity-0 group-hover:opacity-100"
                        }
                        aria-label={"Previous slide"}
                      >
                        <ArrowLeftIcon className={"w-4 h-4 lg:w-5 lg:h-5"} />
                      </button>
                      <button
                        onClick={() => se(Y < Tt - 1 ? Y + 1 : 0)}
                        className={
                          "absolute right-2 lg:right-4 top-1/2 transform -translate-y-1/2 z-30 w-8 h-8 lg:w-10 lg:h-10 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center text-white hover:bg-black/70 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white/50 opacity-0 group-hover:opacity-100"
                        }
                        aria-label={"Next slide"}
                      >
                        <ArrowRightIcon className={"w-4 h-4 lg:w-5 lg:h-5"} />
                      </button>
                    </jsxRuntime.Fragment>
                  )}
                  {Tt > 1 && Y === 0 && (
                    <div
                      className={
                        "absolute bottom-8 lg:bottom-12 left-1/2 transform -translate-x-1/2 z-20"
                      }
                    >
                      <div
                        className={
                          "bg-black/50 backdrop-blur-sm text-white px-3 lg:px-4 py-1 lg:py-2 rounded-full text-[8px] sm:text-xs lg:text-sm flex items-center animate-pulse"
                        }
                      >
                        <ArrowLeftIcon className={"w-3 h-3 mr-1"} />
                        {"Swipe to see demos"}
                        <ArrowRightIcon className={"w-3 h-3 ml-1"} />
                      </div>
                    </div>
                  )}
                  <div className={"absolute top-3 lg:top-4 left-3 lg:left-4 z-20"}>
                    <div className={"relative"}>
                      <div
                        className={"absolute inset-0 bg-red-500 rounded-full blur-md opacity-40"}
                      />
                      <span
                        className={
                          "relative bg-gradient-to-r from-red-500 to-pink-500 text-white px-2 lg:px-3 py-1 lg:py-1.5 rounded-full text-xs font-bold shadow-lg border border-red-400/50"
                        }
                      >
                        {"50% OFF"}
                      </span>
                    </div>
                  </div>
                  <div className={"absolute top-3 lg:top-4 right-3 lg:right-4 z-20"}>
                    <div className={"relative"}>
                      <div
                        className={"absolute inset-0 bg-green-500 rounded-full blur-md opacity-40"}
                      />
                      <span
                        className={
                          "relative bg-gradient-to-r from-green-500 to-emerald-500 text-white px-2 lg:px-3 py-1 lg:py-1.5 rounded-full text-xs font-bold shadow-lg border border-green-400/50"
                        }
                      >
                        {"Best Seller"}
                      </span>
                    </div>
                  </div>
                  {Tt > 1 && (
                    <div
                      className={"absolute top-3 lg:top-4 left-1/2 transform -translate-x-1/2 z-20"}
                    >
                      <div
                        className={
                          "bg-black/50 backdrop-blur-sm text-white px-2 lg:px-3 py-1 lg:py-1.5 rounded-full text-xs lg:text-sm font-medium"
                        }
                      >
                        {Y + 1}
                        {" / "}
                        {Tt}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div
                className={
                  "p-4 lg:p-6 flex flex-col order-2 lg:order-2 bg-gradient-to-br from-white to-slate-50/30"
                }
              >
                <div className={"mb-4 lg:mb-6"}>
                  <div className={"flex flex-col sm:flex-row sm:items-center gap-2 lg:gap-3 mb-2"}>
                    <span className={"text-xl sm:text-2xl lg:text-3xl font-bold text-slate-900"}>
                      {"₹"}
                      {l.amount}
                    </span>
                    <div className={"flex items-center gap-2"}>
                      <span
                        className={"text-base sm:text-lg lg:text-xl line-through text-slate-400"}
                      >
                        {"₹"}
                        {Number(l.amount * 2).toFixed(0)}
                      </span>
                      <span
                        className={
                          "bg-gradient-to-r from-green-100 to-green-200 text-green-800 px-2 py-1 rounded-full text-xs font-bold shadow-sm"
                        }
                      >
                        {"Save 50%"}
                      </span>
                    </div>
                  </div>
                  <p className={"text-xs lg:text-sm text-slate-500"}>
                    {l.category === "hardware" ? "Hardware + Digital Package" : "Digital Download"}
                  </p>
                </div>
                <div className={"mb-4 lg:mb-6"}>
                  <h3
                    className={
                      "text-base lg:text-lg font-bold text-slate-800 mb-2 lg:mb-3 flex items-center"
                    }
                  >
                    <div
                      className={
                        "w-1 h-4 lg:h-5 bg-gradient-to-b from-indigo-500 to-purple-500 rounded-full mr-2"
                      }
                    />
                    {"About This Project"}
                  </h3>
                  <p className={"text-sm lg:text-base text-slate-600 leading-relaxed"}>
                    {l.description}
                  </p>
                </div>
                {l.category === "hardware" && (
                  <div className={"mb-4 lg:mb-6"}>
                    <h3
                      className={
                        "text-base lg:text-lg font-bold text-slate-800 mb-3 lg:mb-4 flex items-center"
                      }
                    >
                      <div
                        className={
                          "w-6 h-6 lg:w-7 lg:h-7 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center mr-2"
                        }
                      >
                        <TruckIcon className={"w-3 h-3 lg:w-4 lg:h-4 text-white"} />
                      </div>
                      {"Delivery Information"}
                    </h3>
                    <div
                      className={
                        "bg-gradient-to-br from-indigo-50 to-blue-50 rounded-lg lg:rounded-xl p-3 lg:p-4 border border-indigo-200 space-y-3 lg:space-y-4"
                      }
                    >
                      <div
                        className={
                          "bg-gradient-to-r from-red-50 to-indigo-50 border-2 border-red-200 rounded-lg p-3"
                        }
                      >
                        <div className={"flex items-start"}>
                          <div
                            className={
                              "w-6 h-6 lg:w-7 lg:h-7 bg-red-100 rounded-lg flex items-center justify-center mr-2 flex-shrink-0"
                            }
                          >
                            <InfoIcon className={"w-3.5 h-3.5 lg:w-4 lg:h-4 text-red-600"} />
                          </div>
                          <div>
                            <p className={"text-red-800 text-sm font-medium mb-1"}>
                              {"The delivery will take 10-15+ business days."}
                            </p>
                            <p className={"text-red-700 text-xs"}>
                              {
                                "Please ensure this will be change based on your location and project."
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          "bg-white rounded-lg p-3 lg:p-4 shadow-sm border border-white/50"
                        }
                      >
                        <div className={"flex items-center justify-between mb-2 lg:mb-3"}>
                          <label
                            className={
                              "text-sm lg:text-base font-bold text-slate-700 flex items-center"
                            }
                          >
                            <div
                              className={
                                "w-5 h-5 lg:w-6 lg:h-6 bg-indigo-100 rounded-lg flex items-center justify-center mr-2"
                              }
                            >
                              <PhoneIcon className={"w-3 h-3 lg:w-3.5 lg:h-3.5 text-indigo-600"} />
                            </div>
                            {"Phone Number *"}
                          </label>
                          {!G.isEditingPhone && (
                            <button
                              onClick={() =>
                                te((_) => ({
                                  ..._,
                                  isEditingPhone: true,
                                }))
                              }
                              className={
                                "p-1.5 lg:p-2 hover:bg-indigo-100 rounded-lg transition-colors group"
                              }
                            >
                              <SquarePenIcon
                                className={
                                  "w-3.5 h-3.5 lg:w-4 lg:h-4 text-indigo-600 group-hover:text-indigo-700"
                                }
                              />
                            </button>
                          )}
                        </div>
                        {G.isEditingPhone ? (
                          <div className={"space-y-2 lg:space-y-3"}>
                            <div className={"relative"}>
                              <input
                                type={"tel"}
                                value={G.phone}
                                onChange={(_) => {
                                  const ee = _.target.value.replace(/\D/g, "").slice(0, 10);
                                  Q("phone", ee);
                                }}
                                className={
                                  "w-full px-3 lg:px-4 py-2 lg:py-2.5 text-sm lg:text-base border-2 border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
                                }
                                placeholder={"Enter 10-digit phone number"}
                                maxLength={10}
                              />
                              <div
                                className={
                                  "absolute right-2 top-1/2 transform -translate-y-1/2 text-xs text-slate-400"
                                }
                              >
                                {G.phone.length}
                                {"/10"}
                              </div>
                            </div>
                            <div className={"flex gap-2"}>
                              <button
                                onClick={() => J("phone")}
                                disabled={G.isSaving || G.phone.length !== 10}
                                className={
                                  "flex-1 flex items-center justify-center px-3 lg:px-4 py-2 lg:py-2.5 bg-gradient-to-r from-indigo-500 to-indigo-600 text-white rounded-lg hover:from-indigo-600 hover:to-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium shadow-lg transition-all"
                                }
                              >
                                {G.isSaving ? (
                                  <div
                                    className={
                                      "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"
                                    }
                                  />
                                ) : (
                                  <SaveIcon className={"w-4 h-4 mr-2"} />
                                )}
                                {"Save"}
                              </button>
                              <button
                                onClick={() =>
                                  te((_) => ({
                                    ..._,
                                    isEditingPhone: false,
                                    phone: (n == null ? undefined : n.phone) || "",
                                  }))
                                }
                                className={
                                  "flex-1 flex items-center justify-center px-3 lg:px-4 py-2 lg:py-2.5 bg-gradient-to-r from-slate-500 to-slate-600 text-white rounded-lg hover:from-slate-600 hover:to-slate-700 text-sm font-medium shadow-lg transition-all"
                                }
                              >
                                <XIcon className={"w-4 h-4 mr-2"} />
                                {"Cancel"}
                              </button>
                            </div>
                            {G.phone.length > 0 && G.phone.length < 10 && (
                              <div
                                className={
                                  "bg-orange-50 border border-orange-200 rounded-lg p-2 flex items-center"
                                }
                              >
                                <CircleAlertIcon
                                  className={"w-4 h-4 text-orange-600 mr-2 flex-shrink-0"}
                                />
                                <p className={"text-orange-700 text-xs"}>
                                  {"Phone number must be exactly 10 digits"}
                                </p>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            className={"bg-slate-50 rounded-lg p-2 lg:p-3 border border-slate-200"}
                          >
                            <span className={"text-sm text-slate-800 font-medium"}>
                              {G.phone || (
                                <span className={"text-slate-400 italic"}>
                                  {"Click edit to add phone number"}
                                </span>
                              )}
                            </span>
                          </div>
                        )}
                        {G.validationErrors.phone && (
                          <div
                            className={
                              "bg-red-50 border border-red-200 rounded-lg p-2 mt-2 flex items-center"
                            }
                          >
                            <CircleAlertIcon
                              className={"w-4 h-4 text-red-600 mr-2 flex-shrink-0"}
                            />
                            <p className={"text-red-700 text-xs"}>{G.validationErrors.phone}</p>
                          </div>
                        )}
                      </div>
                      <div
                        className={
                          "bg-white rounded-lg p-3 lg:p-4 shadow-sm border border-white/50"
                        }
                      >
                        <div className={"flex items-center justify-between mb-2 lg:mb-3"}>
                          <label
                            className={
                              "text-sm lg:text-base font-bold text-slate-700 flex items-center"
                            }
                          >
                            <div
                              className={
                                "w-5 h-5 lg:w-6 lg:h-6 bg-indigo-100 rounded-lg flex items-center justify-center mr-2"
                              }
                            >
                              <MapPinIcon className={"w-3 h-3 lg:w-3.5 lg:h-3.5 text-indigo-600"} />
                            </div>
                            {"Delivery Address *"}
                          </label>
                          {!G.isEditingAddress && (
                            <button
                              onClick={() =>
                                te((_) => ({
                                  ..._,
                                  isEditingAddress: true,
                                }))
                              }
                              className={
                                "p-1.5 lg:p-2 hover:bg-indigo-100 rounded-lg transition-colors group"
                              }
                            >
                              <SquarePenIcon
                                className={
                                  "w-3.5 h-3.5 lg:w-4 lg:h-4 text-indigo-600 group-hover:text-indigo-700"
                                }
                              />
                            </button>
                          )}
                        </div>
                        {G.isEditingAddress ? (
                          <div className={"space-y-2 lg:space-y-3"}>
                            <textarea
                              value={G.address}
                              onChange={(_) => Q("address", _.target.value)}
                              rows={3}
                              className={
                                "w-full px-3 lg:px-4 py-2 lg:py-2.5 text-sm lg:text-base border-2 border-indigo-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent resize-none transition-all"
                              }
                              placeholder={"Enter your complete delivery address"}
                            />
                            <div className={"flex gap-2"}>
                              <button
                                onClick={() => J("address")}
                                disabled={G.isSaving || !G.address.trim()}
                                className={
                                  "flex-1 flex items-center justify-center px-3 lg:px-4 py-2 lg:py-2.5 bg-gradient-to-r from-indigo-500 to-indigo-600 text-white rounded-lg hover:from-indigo-600 hover:to-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium shadow-lg transition-all"
                                }
                              >
                                {G.isSaving ? (
                                  <div
                                    className={
                                      "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"
                                    }
                                  />
                                ) : (
                                  <SaveIcon className={"w-4 h-4 mr-2"} />
                                )}
                                {"Save"}
                              </button>
                              <button
                                onClick={() =>
                                  te((_) => ({
                                    ..._,
                                    isEditingAddress: false,
                                    address: (n == null ? undefined : n.address) || "",
                                  }))
                                }
                                className={
                                  "flex-1 flex items-center justify-center px-3 lg:px-4 py-2 lg:py-2.5 bg-gradient-to-r from-slate-500 to-slate-600 text-white rounded-lg hover:from-slate-600 hover:to-slate-700 text-sm font-medium shadow-lg transition-all"
                                }
                              >
                                <XIcon className={"w-4 h-4 mr-2"} />
                                {"Cancel"}
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div
                            className={"bg-slate-50 rounded-lg p-2 lg:p-3 border border-slate-200"}
                          >
                            <span className={"text-sm text-slate-800 font-medium break-words"}>
                              {G.address || (
                                <span className={"text-slate-400 italic"}>
                                  {"Click edit to add delivery address"}
                                </span>
                              )}
                            </span>
                          </div>
                        )}
                        {G.validationErrors.address && (
                          <div
                            className={
                              "bg-red-50 border border-red-200 rounded-lg p-2 mt-2 flex items-center"
                            }
                          >
                            <CircleAlertIcon
                              className={"w-4 h-4 text-red-600 mr-2 flex-shrink-0"}
                            />
                            <p className={"text-red-700 text-xs"}>{G.validationErrors.address}</p>
                          </div>
                        )}
                      </div>
                      <div
                        className={
                          "bg-gradient-to-r from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-lg p-3"
                        }
                      >
                        <div className={"flex items-start"}>
                          <div
                            className={
                              "w-6 h-6 lg:w-7 lg:h-7 bg-blue-100 rounded-lg flex items-center justify-center mr-2 flex-shrink-0"
                            }
                          >
                            <InfoIcon className={"w-3.5 h-3.5 lg:w-4 lg:h-4 text-blue-600"} />
                          </div>
                          <div>
                            <p className={"text-blue-800 text-sm font-medium mb-1"}>
                              {"Hardware Delivery Required"}
                            </p>
                            <p className={"text-blue-700 text-xs"}>
                              {
                                "Please ensure your contact details are accurate for smooth delivery."
                              }
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className={"mt-auto space-y-4 lg:space-y-5"}>
                  {W.success ? (
                    <motion.div
                      initial={{
                        scale: 0.8,
                        opacity: 0,
                      }}
                      animate={{
                        scale: 1,
                        opacity: 1,
                      }}
                      transition={{
                        duration: 0.5,
                        ease: "easeOut",
                      }}
                      className={
                        "bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-200 rounded-2xl p-6 text-center shadow-lg"
                      }
                    >
                      <motion.div
                        initial={{
                          scale: 0,
                        }}
                        animate={{
                          scale: 1,
                        }}
                        transition={{
                          delay: 0.3,
                          duration: 0.3,
                        }}
                        className={
                          "w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-green-400 to-emerald-500 flex items-center justify-center shadow-lg"
                        }
                      >
                        <CheckIcon className={"w-8 h-8 text-white"} />
                      </motion.div>
                      <motion.h3
                        initial={{
                          y: 20,
                          opacity: 0,
                        }}
                        animate={{
                          y: 0,
                          opacity: 1,
                        }}
                        transition={{
                          delay: 0.4,
                          duration: 0.3,
                        }}
                        className={"text-green-800 font-bold text-lg mb-2"}
                      >
                        {"Payment Successful!"}
                      </motion.h3>
                      <motion.p
                        initial={{
                          y: 20,
                          opacity: 0,
                        }}
                        animate={{
                          y: 0,
                          opacity: 1,
                        }}
                        transition={{
                          delay: 0.5,
                          duration: 0.3,
                        }}
                        className={"text-green-600 text-sm"}
                      >
                        {"Redirecting to your dashboard..."}
                      </motion.p>
                    </motion.div>
                  ) : (
                    <div className={"space-y-4"}>
                      <AnimatePresence>
                        {W.error && (
                          <motion.div
                            initial={{
                              opacity: 0,
                              y: -20,
                              height: 0,
                            }}
                            animate={{
                              opacity: 1,
                              y: 0,
                              height: "auto",
                            }}
                            exit={{
                              opacity: 0,
                              y: -20,
                              height: 0,
                            }}
                            className={
                              "bg-gradient-to-br from-red-50 to-rose-50 border-l-4 border-red-400 rounded-xl p-4 shadow-sm"
                            }
                          >
                            <div className={"flex items-start"}>
                              <div
                                className={
                                  "flex-shrink-0 w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center mr-3"
                                }
                              >
                                <CircleAlertIcon className={"w-4 h-4 text-red-600"} />
                              </div>
                              <div>
                                <h4 className={"text-red-800 font-semibold text-sm mb-1"}>
                                  {"Payment Error"}
                                </h4>
                                <p className={"text-red-600 text-xs"}>{W.error}</p>
                              </div>
                              <button
                                onClick={() =>
                                  B((_) => ({
                                    ..._,
                                    error: null,
                                  }))
                                }
                                className={
                                  "ml-auto text-red-400 hover:text-red-600 transition-colors"
                                }
                              >
                                <XIcon className={"w-4 h-4"} />
                              </button>
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                      <div
                        className={
                          "bg-white border-2 border-gray-100 rounded-2xl p-5 shadow-sm hover:shadow-md transition-shadow duration-300"
                        }
                      >
                        <div className={"space-y-3"}>
                          <div
                            className={
                              "flex items-center justify-between pb-2 border-b border-gray-100"
                            }
                          >
                            <h3 className={"text-gray-800 font-semibold text-base"}>
                              {"Price Details"}
                            </h3>
                            {(b == null ? undefined : b.discount) > 0 && (
                              <span
                                className={
                                  "bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-medium"
                                }
                              >
                                {Math.round((b.discount / b.original_amount) * 100)}
                                {"% OFF"}
                              </span>
                            )}
                          </div>
                          {b ? (
                            <div className={"space-y-2"}>
                              {b.discount > 0 ? (
                                <jsxRuntime.Fragment>
                                  <div className={"flex justify-between items-center text-sm"}>
                                    <span className={"text-gray-600"}>{"Original Price:"}</span>
                                    <span className={"line-through text-gray-500 font-medium"}>
                                      {"₹"}
                                      {b.original_amount}
                                    </span>
                                  </div>
                                  <div className={"flex justify-between items-center text-sm"}>
                                    <span className={"text-green-600 font-medium"}>
                                      {"Coupon Discount:"}
                                    </span>
                                    <span className={"text-green-600 font-semibold"}>
                                      {"-₹"}
                                      {b.discount}
                                    </span>
                                  </div>
                                  <div className={"pt-2 border-t border-gray-100"}>
                                    <div className={"flex justify-between items-center"}>
                                      <span className={"text-gray-900 font-bold text-lg"}>
                                        {"Final Amount:"}
                                      </span>
                                      <span className={"text-indigo-600 font-bold text-xl"}>
                                        {"₹"}
                                        {b.final_amount.toFixed(2)}
                                      </span>
                                    </div>
                                  </div>
                                </jsxRuntime.Fragment>
                              ) : (
                                <div className={"flex justify-between items-center"}>
                                  <span className={"text-gray-900 font-bold text-lg"}>
                                    {"Amount:"}
                                  </span>
                                  <span className={"text-indigo-600 font-bold text-xl"}>
                                    {"₹"}
                                    {b.final_amount.toFixed(2)}
                                  </span>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className={"flex justify-between items-center"}>
                              <span className={"text-gray-900 font-bold text-lg"}>{"Amount:"}</span>
                              <span className={"text-indigo-600 font-bold text-xl"}>
                                {"₹"}
                                {l == null ? undefined : l.amount}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div
                        className={
                          "bg-gradient-to-br from-purple-50 to-indigo-50 border-2 border-purple-100 rounded-2xl p-5 shadow-sm"
                        }
                      >
                        <div className={"flex items-center mb-4"}>
                          <div
                            className={
                              "w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center mr-3"
                            }
                          >
                            <TagIcon className={"w-4 h-4 text-purple-600"} />
                          </div>
                          <h3 className={"text-purple-800 font-semibold text-base"}>
                            {"Have a Coupon Code?"}
                          </h3>
                        </div>
                        {A ? (
                          <motion.div
                            initial={{
                              opacity: 0,
                              scale: 0.95,
                            }}
                            animate={{
                              opacity: 1,
                              scale: 1,
                            }}
                            className={"bg-green-50 border-2 border-green-200 rounded-xl p-4"}
                          >
                            <div className={"flex items-center justify-between mb-2"}>
                              <div className={"flex items-center"}>
                                <div
                                  className={
                                    "w-6 h-6 bg-green-500 rounded-full flex items-center justify-center mr-3"
                                  }
                                >
                                  <CheckIcon className={"w-3 h-3 text-white"} />
                                </div>
                                <span className={"text-green-800 font-semibold text-sm"}>
                                  {"Coupon Applied"}
                                </span>
                              </div>
                              <Button
                                variant={"plain"}
                                size={"sm"}
                                className={
                                  "bg-red-600 text-red-600 inline-flex items-center hover:text-red-700 hover:bg-red-50 px-3 py-1 rounded-lg transition-all duration-200"
                                }
                                onClick={je}
                                disabled={W.inProgress}
                              >
                                <XIcon className={"w-4 h-4 mr-1"} />
                                {" Remove"}
                              </Button>
                            </div>
                            <div className={"flex items-center justify-between"}>
                              <div>
                                <p className={"text-green-700 font-bold text-sm"}>
                                  {b == null ? undefined : b.coupon_applied}
                                </p>
                                <p className={"text-green-600 text-xs"}>
                                  {"You saved ₹"}
                                  {b == null ? undefined : b.discount}
                                </p>
                              </div>
                              <div
                                className={"bg-white px-3 py-1 rounded-lg border border-green-200"}
                              >
                                <span className={"text-green-700 font-bold text-sm"}>
                                  {"-₹"}
                                  {b == null ? undefined : b.discount}
                                </span>
                              </div>
                            </div>
                          </motion.div>
                        ) : (
                          <div className={"space-y-3"}>
                            <div className={"flex gap-3"}>
                              <div className={"flex-1 relative"}>
                                <input
                                  type={"text"}
                                  placeholder={"Enter coupon code"}
                                  value={w}
                                  onChange={(_) => N(_.target.value.toUpperCase())}
                                  className={
                                    "w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm font-medium uppercase tracking-wider placeholder-gray-400 focus:border-purple-400 focus:ring-0 transition-colors duration-200"
                                  }
                                  disabled={W.inProgress}
                                />
                                {w && (
                                  <button
                                    onClick={() => N("")}
                                    className={
                                      "absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                                    }
                                  >
                                    <XIcon className={"w-4 h-4"} />
                                  </button>
                                )}
                              </div>
                              <Button
                                variant={"secondary"}
                                className={
                                  "px-6 py-3 bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-purple-700 hover:to-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-[1.02]"
                                }
                                onClick={he}
                                disabled={W.inProgress || !w.trim()}
                              >
                                {W.inProgress ? (
                                  <div
                                    className={
                                      "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
                                    }
                                  />
                                ) : (
                                  "Apply"
                                )}
                              </Button>
                            </div>
                            {T && (
                              <motion.div
                                initial={{
                                  opacity: 0,
                                  y: -10,
                                }}
                                animate={{
                                  opacity: 1,
                                  y: 0,
                                }}
                                className={
                                  "flex items-start bg-red-50 border border-red-200 rounded-lg p-3"
                                }
                              >
                                <CircleAlertIcon
                                  className={"w-4 h-4 text-red-500 mt-0.5 mr-2 flex-shrink-0"}
                                />
                                <p className={"text-red-700 text-xs"}>{T}</p>
                              </motion.div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className={"space-y-3"}>
                        <Button
                          variant={"primary"}
                          className={
                            "w-full px-6 py-4 text-base rounded-2xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:from-indigo-700 hover:via-purple-700 hover:to-pink-700 text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden group disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                          }
                          onClick={ot}
                          disabled={W.inProgress}
                        >
                          <div
                            className={
                              "absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"
                            }
                          />
                          <div className={"relative flex items-center justify-center"}>
                            {W.inProgress ? (
                              <jsxRuntime.Fragment>
                                <div
                                  className={
                                    "w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"
                                  }
                                />
                                <span>{"Processing Payment..."}</span>
                              </jsxRuntime.Fragment>
                            ) : (
                              <jsxRuntime.Fragment>
                                <ShoppingCartIcon className={"w-5 h-5 mr-2"} />
                                <span className={"flex flex-col items-center"}>
                                  <span>
                                    {"Buy Now - ₹"}
                                    {(b == null ? undefined : b.final_amount.toFixed(2)) ||
                                      (l == null ? undefined : l.amount)}
                                  </span>
                                  <span className={"text-xs opacity-90 font-normal"}>
                                    {(l == null ? undefined : l.category) === "hardware"
                                      ? "(Physical Delivery)"
                                      : "(Instant Access)"}
                                  </span>
                                </span>
                              </jsxRuntime.Fragment>
                            )}
                          </div>
                        </Button>
                        <Link to={"/products"} className={"block"}>
                          <Button
                            variant={"secondary"}
                            className={
                              "w-full px-6 py-3 text-sm border-2 border-gray-200 rounded-2xl text-gray-600 hover:border-indigo-300 hover:bg-gradient-to-r hover:from-indigo-500 hover:to-purple-600 hover:text-white transition-all duration-300 font-medium group transform hover:scale-[1.01] active:scale-[0.99]"
                            }
                          >
                            <div className={"flex items-center justify-center"}>
                              <ArrowLeftIcon className={"w-4 h-4 mr-2 group-hover:animate-pulse"} />
                              {"Browse More Projects"}
                            </div>
                          </Button>
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div
            className={
              "bg-white rounded-xl md:rounded-2xl lg:rounded-3xl shadow-xl overflow-hidden border border-slate-100"
            }
            variants={ne}
          >
            <div
              className={"border-b border-slate-200 bg-gradient-to-r from-slate-50 to-indigo-50"}
            >
              <div className={"flex overflow-x-auto no-scrollbar"}>
                <button
                  onClick={() => g("details")}
                  className={`px-3 md:px-4 lg:px-6 xl:px-8 py-2 md:py-3 lg:py-4 border-b-3 font-semibold text-[10px] md:text-xs lg:text-sm whitespace-nowrap transition-all duration-300 ${p === "details" ? "border-indigo-500 text-indigo-600 bg-white" : "border-transparent text-slate-500 hover:text-slate-700 hover:bg-white/50"}`}
                >
                  {"Project Details"}
                </button>
                <button
                  onClick={() => g("features")}
                  className={`px-3 md:px-4 lg:px-6 xl:px-8 py-2 md:py-3 lg:py-4 border-b-3 font-semibold text-[10px] md:text-xs lg:text-sm whitespace-nowrap transition-all duration-300 ${p === "features" ? "border-indigo-500 text-indigo-600 bg-white" : "border-transparent text-slate-500 hover:text-slate-700 hover:bg-white/50"}`}
                >
                  {"Features"}
                </button>
                {Re.length > 0 && (
                  <button
                    onClick={() => g("faq")}
                    className={`px-3 md:px-4 lg:px-6 xl:px-8 py-2 md:py-3 lg:py-4 border-b-3 font-semibold text-[10px] md:text-xs lg:text-sm whitespace-nowrap transition-all duration-300 ${p === "faq" ? "border-indigo-500 text-indigo-600 bg-white" : "border-transparent text-slate-500 hover:text-slate-700 hover:bg-white/50"}`}
                  >
                    {"FAQ"}
                  </button>
                )}
              </div>
            </div>
            <div className={"p-4 md:p-6 lg:p-8 xl:p-12"}>
              {p === "details" && (
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 20,
                  }}
                  animate={{
                    opacity: 1,
                    y: 0,
                  }}
                  transition={{
                    duration: 0.3,
                  }}
                >
                  <div
                    className={
                      "grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 lg:gap-8 mb-4 md:mb-6 lg:mb-8"
                    }
                  >
                    <div
                      className={
                        "bg-gradient-to-br from-slate-50 to-indigo-50 rounded-lg md:rounded-xl lg:rounded-2xl p-3 md:p-4 lg:p-6 border border-slate-200"
                      }
                    >
                      <h3
                        className={
                          "text-slate-900 font-bold mb-3 md:mb-4 lg:mb-6 flex items-center text-sm md:text-base lg:text-lg"
                        }
                      >
                        <CodeIcon
                          className={
                            "w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-1 md:mr-2 lg:mr-3 text-indigo-600"
                          }
                        />
                        {"Technical Specifications"}
                      </h3>
                      <div className={"space-y-2 md:space-y-3 lg:space-y-4"}>
                        <div
                          className={"flex justify-between py-1 md:py-2 border-b border-slate-200"}
                        >
                          <span
                            className={
                              "text-slate-600 font-medium text-[10px] md:text-xs lg:text-sm xl:text-base"
                            }
                          >
                            {"Programming Language:"}
                          </span>
                          <span
                            className={
                              "text-slate-800 font-semibold text-[10px] md:text-xs lg:text-sm xl:text-base"
                            }
                          >
                            {l.language}
                          </span>
                        </div>
                        <div
                          className={"flex justify-between py-1 md:py-2 border-b border-slate-200"}
                        >
                          <span
                            className={
                              "text-slate-600 font-medium text-[10px] md:text-xs lg:text-sm xl:text-base"
                            }
                          >
                            {"Category:"}
                          </span>
                          <span
                            className={
                              "text-slate-800 font-semibold text-[10px] md:text-xs lg:text-sm xl:text-base"
                            }
                          >
                            {l.category === "hardware" ? "Hardware" : l.category}
                          </span>
                        </div>
                        {l.category === "hardware" && (
                          <div
                            className={
                              "flex justify-between py-1 md:py-2 border-b border-slate-200"
                            }
                          >
                            <span
                              className={
                                "text-slate-600 font-medium text-[10px] md:text-xs lg:text-sm xl:text-base"
                              }
                            >
                              {"Delivery Type:"}
                            </span>
                            <span
                              className={
                                "text-slate-800 font-semibold text-[10px] md:text-xs lg:text-sm xl:text-base flex items-center"
                              }
                            >
                              <TruckIcon className={"w-3 h-3 md:w-4 md:h-4 mr-1 text-indigo-600"} />
                              {"Physical Hardware"}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <div
                      className={
                        "bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg md:rounded-xl lg:rounded-2xl p-3 md:p-4 lg:p-6 border border-purple-200"
                      }
                    >
                      <h3
                        className={
                          "text-slate-900 font-bold mb-3 md:mb-4 lg:mb-6 flex items-center text-sm md:text-base lg:text-lg"
                        }
                      >
                        <PackageIcon
                          className={
                            "w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-1 md:mr-2 lg:mr-3 text-purple-600"
                          }
                        />
                        {"Package Contents"}
                      </h3>
                      <div className={"space-y-2 md:space-y-3 lg:space-y-4"}>
                        <div
                          className={"flex justify-between py-1 md:py-2 border-b border-purple-200"}
                        >
                          <span
                            className={
                              "text-slate-600 font-medium text-[10px] md:text-xs lg:text-sm xl:text-base"
                            }
                          >
                            {"Files Included:"}
                          </span>
                          <span
                            className={
                              "text-slate-800 font-semibold text-[10px] md:text-xs lg:text-sm xl:text-base"
                            }
                          >
                            {l.files || "Complete Package"}
                          </span>
                        </div>
                        <div
                          className={"flex justify-between py-1 md:py-2 border-b border-purple-200"}
                        >
                          <span
                            className={
                              "text-slate-600 font-medium text-[10px] md:text-xs lg:text-sm xl:text-base"
                            }
                          >
                            {"Documentation:"}
                          </span>
                          <span
                            className={
                              "text-slate-800 font-semibold text-[10px] md:text-xs lg:text-sm xl:text-base"
                            }
                          >
                            {l.documentation || "Comprehensive"}
                          </span>
                        </div>
                        {l.category === "hardware" && (
                          <div
                            className={
                              "flex justify-between py-1 md:py-2 border-b border-purple-200"
                            }
                          >
                            <span
                              className={
                                "text-slate-600 font-medium text-[10px] md:text-xs lg:text-sm xl:text-base"
                              }
                            >
                              {"Hardware Components:"}
                            </span>
                            <span
                              className={
                                "text-slate-800 font-semibold text-[10px] md:text-xs lg:text-sm xl:text-base"
                              }
                            >
                              {"Included"}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      "bg-gradient-to-r from-blue-50 to-cyan-50 rounded-lg md:rounded-xl lg:rounded-2xl p-4 md:p-6 lg:p-8 border border-blue-200"
                    }
                  >
                    <h3
                      className={
                        "text-slate-900 font-bold mb-2 md:mb-3 lg:mb-4 flex items-center text-sm md:text-base lg:text-lg"
                      }
                    >
                      <InfoIcon
                        className={
                          "w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-1 md:mr-2 lg:mr-3 text-blue-600"
                        }
                      />
                      {"Project Description"}
                    </h3>
                    <p className={"text-slate-700 leading-relaxed text-xs md:text-sm lg:text-base"}>
                      {l.description}
                    </p>
                  </div>
                </motion.div>
              )}
              {p === "features" && (
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 20,
                  }}
                  animate={{
                    opacity: 1,
                    y: 0,
                  }}
                  transition={{
                    duration: 0.3,
                  }}
                >
                  <h3
                    className={
                      "text-lg md:text-xl lg:text-2xl font-bold text-slate-900 mb-4 md:mb-6 lg:mb-8 flex items-center"
                    }
                  >
                    <TagIcon
                      className={
                        "w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-1 md:mr-2 lg:mr-3 text-indigo-600"
                      }
                    />
                    {"Key Features & Highlights"}
                  </h3>
                  {Mt.length > 0 ? (
                    <div className={"grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 lg:gap-6"}>
                      {Mt.map((_, ee) => (
                        <motion.div
                          key={ee}
                          initial={{
                            opacity: 0,
                            x: -20,
                          }}
                          animate={{
                            opacity: 1,
                            x: 0,
                          }}
                          transition={{
                            delay: ee * 0.1,
                          }}
                          className={
                            "flex items-start p-2 md:p-3 lg:p-4 bg-gradient-to-r from-slate-50 to-indigo-50 rounded-lg md:rounded-xl border border-slate-200 hover:shadow-md transition-all duration-300"
                          }
                        >
                          <div
                            className={
                              "w-5 h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 rounded-full bg-indigo-500 flex items-center justify-center mr-2 md:mr-3 lg:mr-4 flex-shrink-0"
                            }
                          >
                            <CheckIcon
                              className={"w-2 h-2 md:w-3 md:h-3 lg:w-4 lg:h-4 text-white"}
                            />
                          </div>
                          <p
                            className={"text-slate-700 font-medium text-xs md:text-sm lg:text-base"}
                          >
                            {_}
                          </p>
                        </motion.div>
                      ))}
                    </div>
                  ) : (
                    <div
                      className={
                        "text-center py-8 md:py-12 lg:py-16 bg-gradient-to-r from-slate-50 to-indigo-50 rounded-lg md:rounded-xl lg:rounded-2xl border border-slate-200"
                      }
                    >
                      <p className={"text-slate-500 text-sm md:text-base lg:text-lg"}>
                        {"No specific features listed for this project."}
                      </p>
                    </div>
                  )}
                </motion.div>
              )}
              {p === "faq" && (
                <motion.div
                  initial={{
                    opacity: 0,
                    y: 20,
                  }}
                  animate={{
                    opacity: 1,
                    y: 0,
                  }}
                  transition={{
                    duration: 0.3,
                  }}
                >
                  <h3
                    className={
                      "text-lg md:text-xl lg:text-2xl font-bold text-slate-900 mb-4 md:mb-6 lg:mb-8 flex items-center"
                    }
                  >
                    <InfoIcon
                      className={
                        "w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 mr-1 md:mr-2 lg:mr-3 text-indigo-600"
                      }
                    />
                    {"Frequently Asked Questions"}
                  </h3>
                  {Re.length > 0 ? (
                    <div className={"space-y-3 md:space-y-4 lg:space-y-6"}>
                      {Re.map((_, ee) => (
                        <motion.div
                          key={ee}
                          initial={{
                            opacity: 0,
                            y: 20,
                          }}
                          animate={{
                            opacity: 1,
                            y: 0,
                          }}
                          transition={{
                            delay: ee * 0.1,
                          }}
                          className={
                            "bg-white rounded-lg md:rounded-xl lg:rounded-2xl p-3 md:p-4 lg:p-6 border border-slate-200 hover:shadow-lg transition-all duration-300"
                          }
                        >
                          <h4
                            className={
                              "font-bold text-slate-900 mb-1 md:mb-2 lg:mb-3 text-sm md:text-base lg:text-lg"
                            }
                          >
                            {_.question}
                          </h4>
                          <p
                            className={
                              "text-slate-700 leading-relaxed text-xs md:text-sm lg:text-base"
                            }
                          >
                            {_.answer}
                          </p>
                        </motion.div>
                      ))}
                    </div>
                  ) : (
                    <div
                      className={
                        "text-center py-8 md:py-12 lg:py-16 bg-gradient-to-r from-slate-50 to-indigo-50 rounded-lg md:rounded-xl lg:rounded-2xl border border-slate-200"
                      }
                    >
                      <p className={"text-slate-500 text-sm md:text-base lg:text-lg"}>
                        {"No FAQs available for this project."}
                      </p>
                    </div>
                  )}
                </motion.div>
              )}
            </div>
          </motion.div>
        </motion.div>
      </main>
      <motion.section
        className={
          "bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600 text-white py-12 md:py-16 lg:py-20 relative overflow-hidden"
        }
        initial={{
          opacity: 0,
          y: 30,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          delay: 0.5,
          duration: 0.6,
        }}
      >
        <div className={"absolute inset-0 bg-black/20"} />
        <div className={"absolute inset-0 bg-gradient-to-br from-white/5 to-transparent"} />
        <div className={"absolute inset-0"}>
          <div
            className={
              "absolute top-10 left-1/4 w-32 h-32 md:w-56 md:h-56 lg:w-80 lg:h-80 bg-white/10 rounded-full blur-3xl animate-pulse"
            }
          />
          <div
            className={
              "absolute bottom-10 right-1/3 w-40 h-40 md:w-72 md:h-72 lg:w-96 lg:h-96 bg-white/8 rounded-full blur-3xl animate-pulse"
            }
            style={{
              animationDelay: "1s",
            }}
          />
          <div
            className={
              "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-24 md:w-40 md:h-40 bg-white/5 rounded-full blur-2xl"
            }
          />
        </div>
        <div className={"w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10"}>
          <motion.div
            initial={{
              scale: 0.95,
              opacity: 0,
            }}
            animate={{
              scale: 1,
              opacity: 1,
            }}
            transition={{
              delay: 0.7,
              duration: 0.5,
            }}
            className={"text-center"}
          >
            <motion.h2
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{
                y: 0,
                opacity: 1,
              }}
              transition={{
                delay: 0.8,
                duration: 0.5,
              }}
              className={
                "text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-extrabold mb-4 md:mb-6 leading-tight text-white"
              }
            >
              {l.category === "hardware"
                ? "Ready to Build Something Amazing?"
                : "Ready to Excel in Your Studies?"}
            </motion.h2>
            <motion.p
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{
                y: 0,
                opacity: 1,
              }}
              transition={{
                delay: 0.9,
                duration: 0.5,
              }}
              className={
                "text-indigo-100 max-w-3xl mx-auto mb-8 md:mb-10 text-sm md:text-base lg:text-lg xl:text-xl leading-relaxed font-medium"
              }
            >
              {l.category === "hardware"
                ? "Get instant access to this hardware project with complete components, source code, and comprehensive documentation delivered to your door."
                : "Get instant access to this premium project with complete source code, comprehensive documentation, and AI-powered explanations to boost your learning."}
            </motion.p>
            <motion.div
              initial={{
                y: 30,
                opacity: 0,
              }}
              animate={{
                y: 0,
                opacity: 1,
              }}
              transition={{
                delay: 1,
                duration: 0.5,
              }}
              className={"max-w-2xl mx-auto mb-8"}
            >
              <div
                className={
                  "bg-white/15 backdrop-blur-lg border border-white/30 rounded-3xl p-6 mb-6 shadow-2xl"
                }
              >
                <div className={"text-center space-y-4"}>
                  {b && b.discount > 0 ? (
                    <div className={"space-y-4"}>
                      <motion.div
                        initial={{
                          scale: 0,
                        }}
                        animate={{
                          scale: 1,
                        }}
                        className={
                          "inline-flex items-center bg-gradient-to-r from-green-500 to-emerald-500 text-white px-6 py-3 rounded-full text-sm font-bold shadow-lg"
                        }
                      >
                        <TagIcon className={"w-4 h-4 mr-2"} />
                        {Math.round((b.discount / b.original_amount) * 100)}
                        {"% OFF Applied!"}
                      </motion.div>
                      <div className={"flex items-center justify-center space-x-4"}>
                        <span
                          className={"text-white/70 line-through text-xl md:text-2xl font-semibold"}
                        >
                          {"₹"}
                          {b.original_amount.toFixed(2)}
                        </span>
                        <span
                          className={
                            "bg-gradient-to-r from-red-500 to-pink-500 text-white px-4 py-2 rounded-xl text-sm font-bold shadow-md"
                          }
                        >
                          {"-₹"}
                          {b.discount}
                        </span>
                      </div>
                      <div className={"text-center"}>
                        <div
                          className={
                            "text-4xl md:text-5xl lg:text-6xl font-black text-white mb-2 drop-shadow-lg"
                          }
                        >
                          {"₹"}
                          {b.final_amount.toFixed(2)}
                        </div>
                        <div
                          className={
                            "text-green-300 font-semibold text-base bg-green-500/20 px-4 py-2 rounded-full inline-block"
                          }
                        >
                          {'Coupon "'}
                          {b.coupon_applied}
                          {'" Applied ✓'}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className={"text-center space-y-2"}>
                      <div
                        className={
                          "text-4xl md:text-5xl lg:text-6xl font-black text-white mb-2 drop-shadow-lg"
                        }
                      >
                        {"₹"}
                        {(b == null ? undefined : b.final_amount.toFixed(2)) || l.amount}
                      </div>
                      <div className={"text-white/80 font-medium text-lg"}>
                        {l.category === "hardware" ? "Complete Hardware Kit" : "Digital Download"}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {A ? (
                <motion.div
                  initial={{
                    opacity: 0,
                    scale: 0.95,
                  }}
                  animate={{
                    opacity: 1,
                    scale: 1,
                  }}
                  className={
                    "bg-green-500/20 backdrop-blur-sm border-2 border-green-400/50 rounded-3xl p-6 max-w-md mx-auto shadow-xl"
                  }
                >
                  <div className={"flex items-center justify-between"}>
                    <div className={"flex items-center text-green-100"}>
                      <div
                        className={
                          "w-10 h-10 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full flex items-center justify-center mr-4 shadow-lg"
                        }
                      >
                        <CheckIcon className={"w-5 h-5 text-white"} />
                      </div>
                      <div>
                        <div className={"font-bold text-base"}>{"Coupon Applied!"}</div>
                        <div className={"text-sm opacity-90"}>
                          {"Code: "}
                          {b == null ? undefined : b.coupon_applied}
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={je}
                      className={
                        "text-red-300 hover:text-red-200 transition-colors p-3 rounded-xl hover:bg-red-500/20 group"
                      }
                      disabled={W.inProgress}
                    >
                      <XIcon className={"w-5 h-5 group-hover:scale-110 transition-transform"} />
                    </button>
                  </div>
                </motion.div>
              ) : (
                <div className={"space-y-4"}>
                  <div className={"flex items-center justify-center mb-4"}>
                    <div
                      className={
                        "flex items-center text-yellow-300 bg-yellow-500/20 px-4 py-2 rounded-full"
                      }
                    >
                      <TagIcon className={"w-5 h-5 mr-2"} />
                      <span className={"font-semibold"}>{"Have a discount code?"}</span>
                    </div>
                  </div>
                  <div className={"flex flex-col sm:flex-row gap-3 max-w-md mx-auto"}>
                    <div className={"flex-1 relative"}>
                      <input
                        type={"text"}
                        placeholder={"Enter coupon code"}
                        value={w}
                        onChange={(_) => N(_.target.value.toUpperCase())}
                        className={
                          "w-full px-6 py-4 rounded-2xl text-gray-800 text-base font-semibold uppercase tracking-wider placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-white/30 border-2 border-white/20 focus:border-white/60 transition-all duration-200 shadow-lg backdrop-blur-sm bg-white/95"
                        }
                        disabled={W.inProgress}
                      />
                      {w && (
                        <button
                          onClick={() => N("")}
                          className={
                            "absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors p-1 hover:bg-gray-100 rounded-full"
                          }
                        >
                          <XIcon className={"w-5 h-5"} />
                        </button>
                      )}
                    </div>
                    <button
                      className={`px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold rounded-2xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none min-w-[120px] ${W.inProgress ? "cursor-not-allowed" : "cursor-pointer"}`}
                      onClick={he}
                      disabled={W.inProgress || !w.trim()}
                    >
                      {W.inProgress ? (
                        <div
                          className={
                            "w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"
                          }
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                  <AnimatePresence>
                    {T && (
                      <motion.div
                        initial={{
                          opacity: 0,
                          y: -10,
                        }}
                        animate={{
                          opacity: 1,
                          y: 0,
                        }}
                        exit={{
                          opacity: 0,
                          y: -10,
                        }}
                        className={
                          "bg-red-500/20 backdrop-blur-sm border border-red-300/50 text-red-100 px-6 py-4 rounded-2xl text-sm font-medium max-w-md mx-auto shadow-lg"
                        }
                      >
                        <div className={"flex items-center"}>
                          <CircleAlertIcon className={"w-5 h-5 mr-3 flex-shrink-0"} />
                          {T}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              )}
            </motion.div>
            <motion.div
              initial={{
                y: 30,
                opacity: 0,
              }}
              animate={{
                y: 0,
                opacity: 1,
              }}
              transition={{
                delay: 1.1,
                duration: 0.5,
              }}
              className={"mb-10"}
            >
              <button
                onClick={ot}
                disabled={W.inProgress}
                className={`
        group relative inline-flex items-center justify-center gap-3
        min-w-[200px] md:min-w-[320px] h-14 md:h-16
        px-6 md:px-10 text-base md:text-lg font-bold
        bg-gradient-to-r from-indigo-600 to-purple-600
        hover:from-indigo-700 hover:to-purple-700
        text-white 
        rounded-2xl shadow-xl 
        transition-all duration-300 transform 
        overflow-hidden
        border-2 border-white/20
        ${W.inProgress ? "cursor-not-allowed opacity-70" : "hover:scale-105 hover:shadow-purple-500/25 active:scale-95 cursor-pointer hover:-translate-y-1"}
      `}
              >
                <div
                  className={
                    "absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  }
                />
                <div
                  className={
                    "absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"
                  }
                />
                <div className={"relative flex items-center justify-center gap-3 z-10"}>
                  {W.inProgress ? (
                    <jsxRuntime.Fragment>
                      <div
                        className={
                          "w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin flex-shrink-0"
                        }
                      />
                      <div className={"flex flex-col items-center leading-tight"}>
                        <span className={"text-base md:text-lg"}>{"Processing Payment..."}</span>
                        <span className={"text-xs font-normal opacity-90"}>
                          {"Securing your purchase"}
                        </span>
                      </div>
                    </jsxRuntime.Fragment>
                  ) : (
                    <jsxRuntime.Fragment>
                      <div
                        className={
                          "flex items-center justify-center w-9 h-9 bg-white/20 rounded-xl flex-shrink-0 group-hover:bg-white/30 transition-all backdrop-blur-sm group-hover:rotate-12 group-hover:scale-110"
                        }
                      >
                        <ShoppingCartIcon className={"w-5 h-5 text-white"} />
                      </div>
                      <div className={"flex items-center"}>
                        <span className={"leading-none drop-shadow-lg text-base md:text-lg font-black"}>
                          {"Buy Now"}
                        </span>
                      </div>
                    </jsxRuntime.Fragment>
                  )}
                </div>
                <div
                  className={
                    "absolute -inset-1 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl opacity-20 group-hover:opacity-40 blur-lg transition-opacity duration-300 -z-10"
                  }
                />
              </button>
            </motion.div>
            <motion.div
              initial={{
                y: 20,
                opacity: 0,
              }}
              animate={{
                y: 0,
                opacity: 1,
              }}
              transition={{
                delay: 1.2,
                duration: 0.5,
              }}
              className={
                "grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-4xl mx-auto opacity-90"
              }
            >
              <div
                className={
                  "flex flex-col items-center text-center group hover:scale-110 transition-all duration-300 cursor-pointer"
                }
              >
                <div
                  className={
                    "w-14 h-14 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-3 group-hover:bg-white/30 transition-all shadow-lg border border-white/20"
                  }
                >
                  <CheckIcon className={"w-7 h-7 group-hover:scale-110 transition-transform"} />
                </div>
                <span className={"text-sm md:text-base font-semibold"}>
                  {l.category === "hardware" ? "Fast Delivery" : "Instant Download"}
                </span>
              </div>
              <div
                className={
                  "flex flex-col items-center text-center group hover:scale-110 transition-all duration-300 cursor-pointer"
                }
              >
                <div
                  className={
                    "w-14 h-14 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-3 group-hover:bg-white/30 transition-all shadow-lg border border-white/20"
                  }
                >
                  <CheckIcon className={"w-7 h-7 group-hover:scale-110 transition-transform"} />
                </div>
                <span className={"text-sm md:text-base font-semibold"}>{"Lifetime Updates"}</span>
              </div>
              <div
                className={
                  "flex flex-col items-center text-center group hover:scale-110 transition-all duration-300 cursor-pointer"
                }
              >
                <div
                  className={
                    "w-14 h-14 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-3 group-hover:bg-white/30 transition-all shadow-lg border border-white/20"
                  }
                >
                  <CheckIcon className={"w-7 h-7 group-hover:scale-110 transition-transform"} />
                </div>
                <span className={"text-sm md:text-base font-semibold"}>{"Expert Support"}</span>
              </div>
              {l.category === "hardware" ? (
                <div
                  className={
                    "flex flex-col items-center text-center group hover:scale-110 transition-all duration-300 cursor-pointer"
                  }
                >
                  <div
                    className={
                      "w-14 h-14 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-3 group-hover:bg-white/30 transition-all shadow-lg border border-white/20"
                    }
                  >
                    <CheckIcon className={"w-7 h-7 group-hover:scale-110 transition-transform"} />
                  </div>
                  <span className={"text-sm md:text-base font-semibold"}>
                    {"Hardware Included"}
                  </span>
                </div>
              ) : Ss.length > 0 ? (
                <div
                  className={
                    "flex flex-col items-center text-center group hover:scale-110 transition-all duration-300 cursor-pointer"
                  }
                >
                  <div
                    className={
                      "w-14 h-14 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-3 group-hover:bg-white/30 transition-all shadow-lg border border-white/20"
                    }
                  >
                    <CheckIcon className={"w-7 h-7 group-hover:scale-110 transition-transform"} />
                  </div>
                  <span className={"text-sm md:text-base font-semibold"}>{"Video Demos"}</span>
                </div>
              ) : (
                <div
                  className={
                    "flex flex-col items-center text-center group hover:scale-110 transition-all duration-300 cursor-pointer"
                  }
                >
                  <div
                    className={
                      "w-14 h-14 bg-gradient-to-br from-white/20 to-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-3 group-hover:bg-white/30 transition-all shadow-lg border border-white/20"
                    }
                  >
                    <CheckIcon className={"w-7 h-7 group-hover:scale-110 transition-transform"} />
                  </div>
                  <span className={"text-sm md:text-base font-semibold"}>{"Premium Quality"}</span>
                </div>
              )}
            </motion.div>
            <AnimatePresence>
              {W.success && (
                <motion.div
                  initial={{
                    opacity: 0,
                    scale: 0.8,
                  }}
                  animate={{
                    opacity: 1,
                    scale: 1,
                  }}
                  exit={{
                    opacity: 0,
                    scale: 0.8,
                  }}
                  className={
                    "fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
                  }
                >
                  <motion.div
                    initial={{
                      y: 50,
                      opacity: 0,
                    }}
                    animate={{
                      y: 0,
                      opacity: 1,
                    }}
                    className={
                      "bg-white rounded-3xl p-8 max-w-md w-full text-center shadow-2xl border border-gray-200"
                    }
                  >
                    <motion.div
                      initial={{
                        scale: 0,
                      }}
                      animate={{
                        scale: 1,
                      }}
                      transition={{
                        delay: 0.2,
                        type: "spring",
                        bounce: 0.5,
                      }}
                      className={
                        "w-20 h-20 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg"
                      }
                    >
                      <CheckIcon className={"w-10 h-10 text-white"} />
                    </motion.div>
                    <h3 className={"text-2xl font-bold text-gray-900 mb-3"}>
                      {"Payment Successful!"}
                    </h3>
                    <p className={"text-gray-600 mb-4"}>
                      {"Thank you for your purchase. Redirecting to your dashboard..."}
                    </p>
                    <div className={"w-full bg-gray-200 rounded-full h-2"}>
                      <div
                        className={
                          "bg-gradient-to-r from-green-500 to-emerald-500 h-2 rounded-full animate-pulse"
                        }
                        style={{
                          width: "100%",
                        }}
                      />
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        </div>
      </motion.section>
      <Footer />
    </div>
  );
};
export { ProductDetailsPage };